import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';
import { toast } from 'sonner';
import { User, Shield, CheckCircle, Lock } from 'lucide-react';

export default function Profile() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!newPassword || newPassword.length < 4) {
      toast.error('La contrasena debe tener al menos 4 caracteres');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/change-password', {
        current_password: currentPassword || null,
        new_password: newPassword,
      });
      toast.success('Contrasena actualizada');
      setCurrentPassword('');
      setNewPassword('');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al cambiar contrasena');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 animate-fade-in" data-testid="profile-page">
      <h2 className="text-2xl lg:text-3xl font-extrabold gold-text" style={{ fontFamily: 'Montserrat' }}>Perfil de Usuario</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="glass-card p-6 space-y-4 gold-border">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#BF953F] to-[#B38728] flex items-center justify-center">
            <User size={28} className="text-[#0A0F1C]" />
          </div>
          <div>
            <h3 className="text-white font-bold text-lg" style={{ fontFamily: 'Montserrat' }}>{user?.user_id}</h3>
            <p className="text-[#F4E39E] text-sm font-semibold">{user?.role === 'admin' ? 'Super Admin' : 'Usuario VIP'}</p>
          </div>
        </div>

        <div className="space-y-3 pt-2">
          <div className="flex items-center gap-3 text-sm">
            <Shield size={16} className="text-[#F4E39E]" />
            <span className="text-white/50">ID de usuario:</span>
            <span className="text-white font-semibold" data-testid="profile-user-id">{user?.user_id}</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <User size={16} className="text-[#F4E39E]" />
            <span className="text-white/50">Rango:</span>
            <span className="text-white font-semibold">{user?.role === 'admin' ? 'Super Admin' : 'User VIP'}</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <CheckCircle size={16} className="text-green-400" />
            <span className="text-white/50">Estado:</span>
            <span className="text-green-400 font-semibold">Activo</span>
          </div>
        </div>
      </div>

      <div className="glass-card p-6 gold-border">
        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" style={{ fontFamily: 'Montserrat' }}>
          <Lock size={18} className="text-[#F4E39E]" /> Cambiar Contrasena
        </h3>
        <form onSubmit={handleChangePassword} className="space-y-3">
          <div>
            <label className="text-white/60 text-sm mb-1 block">Contrasena actual</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              data-testid="current-password-input"
              className="w-full bg-[#0A0F1C] border border-[#F4E39E]/40 rounded-lg px-4 py-3 text-white focus:border-[#F4E39E] focus:ring-1 focus:ring-[#F4E39E] outline-none transition-all"
            />
          </div>
          <div>
            <label className="text-white/60 text-sm mb-1 block">Nueva contrasena</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              data-testid="new-password-input"
              className="w-full bg-[#0A0F1C] border border-[#F4E39E]/40 rounded-lg px-4 py-3 text-white focus:border-[#F4E39E] focus:ring-1 focus:ring-[#F4E39E] outline-none transition-all"
            />
          </div>
          <button type="submit" disabled={saving} data-testid="change-password-button" className="gold-btn w-full py-3 rounded-lg font-bold">
            {saving ? 'Guardando...' : 'Cambiar Contrasena'}
          </button>
        </form>
      </div>
      </div>
    </div>
  );
}
